import * as React from 'react'
import GlobalStyles from 'styles/global'

type MainLayoutProps = {
  children: React.ReactNode
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => (
  <>
    <GlobalStyles />
    {children}
  </>
)

export default MainLayout
